import { useEffect, useMemo, useState } from 'react';
import butterfly1 from '../../assets/images/pedometer/butterfly-1.gif';
import butterfly2 from '../../assets/images/pedometer/butterfly-2.gif';
import butterfly3 from '../../assets/images/pedometer/butterfly-3.gif';
import shootingStar from '../../assets/images/pedometer/shootingstar-night.png';
import firefly from '../../assets/images/pedometer/firefly-night.png';

const BUTTERFLY_SRCS = [butterfly1, butterfly2, butterfly3];

/** 낮: 고양이 근처 + 화면 곳곳 */
const BUTTERFLY_SLOTS = [
  // { src: 0, left: 22, top: 38, size: 26, path: 'a', duration: 15, delay: 0 },
  { src: 1, left: 58, top: 34, size: 18, path: 'b', duration: 18, delay: 2.2 },
  { src: 2, left: 40, top: 48, size: 18, path: 'c', duration: 16, delay: 4.5 },
  { src: 0, left: 72, top: 44, size: 18, path: 'a', duration: 17, delay: 1.1 },
  { src: 1, left: 12, top: 52, size: 18, path: 'b', duration: 19, delay: 0 },
];

/** 밤: 꽃밭 쪽 뭉치 반딧불 */
const FIREFLY_CLUSTERS = [
  { cx: 28, cy: 58, count: 4, seed: 1 },
  { cx: 52, cy: 62, count: 3, seed: 2 },
  { cx: 68, cy: 55, count: 3, seed: 3 },
];

/** 레퍼런스 GIF 별 비행 ~0.56s + 페이드 ≈ 0.75s */
const STAR_FLIGHT_MS = 750;
const STAR_GAP_MS = 10000;

function buildFireflies() {
  const list = [];
  FIREFLY_CLUSTERS.forEach((cluster, clusterIndex) => {
    for (let i = 0; i < cluster.count; i += 1) {
      const t = cluster.seed * 17 + i * 11;
      list.push({
        id: `f-${clusterIndex}-${i}`,
        left: cluster.cx + ((t % 9) - 4) * 1.8,
        top: cluster.cy + ((t % 7) - 3) * 1.4,
        size: 18 + (t % 5) * 2,
        duration: 2.4 + (t % 5) * 0.35,
        delay: (t % 10) * 0.22,
        path: i % 3,
      });
    }
  });
  return list;
}

/**
 * 산책 씬 연출: 낮 나비 / 밤 별똥별·반딧불
 * active=false 이면 마운트만 유지하고 애니 정지
 */
function PedometerSceneFx({ night, active }) {
  const fireflies = useMemo(() => buildFireflies(), []);
  const [starKey, setStarKey] = useState(0);
  const [showStar, setShowStar] = useState(false);

  // 별똥별: 레퍼런스처럼 짧게 한 번 지나간 뒤 간격 두고 재재생
  useEffect(() => {
    if (!night || !active) {
      setShowStar(false);
      return undefined;
    }

    let cancelled = false;
    let hideTimer;
    let gapTimer;

    const play = () => {
      if (cancelled) return;
      setStarKey((key) => key + 1);
      setShowStar(true);
      hideTimer = window.setTimeout(() => {
        if (!cancelled) setShowStar(false);
      }, STAR_FLIGHT_MS);
      gapTimer = window.setTimeout(play, STAR_FLIGHT_MS + STAR_GAP_MS);
    };

    const startTimer = window.setTimeout(play, 1200);

    return () => {
      cancelled = true;
      window.clearTimeout(startTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(gapTimer);
    };
  }, [night, active]);

  if (!active) {
    return null;
  }

  return (
    <div className="pdm-fx" aria-hidden="true">
      {!night &&
        BUTTERFLY_SLOTS.map((slot, index) => (
          <img
            // eslint-disable-next-line react/no-array-index-key
            key={`bf-${index}`}
            src={BUTTERFLY_SRCS[slot.src]}
            alt=""
            className={`pdm-fx__butterfly pdm-fx__butterfly--${slot.path}`}
            style={{
              left: `${slot.left}%`,
              top: `${slot.top}%`,
              width: slot.size,
              animationDuration: `${slot.duration}s`,
              animationDelay: `${slot.delay}s`,
            }}
          />
        ))}

      {night && (
        <>
          {showStar && (
            <div key={starKey} className="pdm-fx__star-run">
              <img src={shootingStar} alt="" className="pdm-fx__star" />
            </div>
          )}
          {fireflies.map((item) => (
            <img
              key={item.id}
              src={firefly}
              alt=""
              className={`pdm-fx__firefly pdm-fx__firefly--${item.path}`}
              style={{
                left: `${item.left}%`,
                top: `${item.top}%`,
                width: item.size,
                animationDuration: `${item.duration}s`,
                animationDelay: `${item.delay}s`,
              }}
            />
          ))}
        </>
      )}
    </div>
  );
}

export default PedometerSceneFx;
